"use client";
import React, { useEffect, useState } from "react";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";

const AboutMBVariant = ({ call = false, data = {}, title_fw_style }) => {
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section className={`section-center ${s.about}`}>
      <div className={s.about_wrapper}>
        <article className={s.bg_image_container_inner}>
          <img
            loading="lazy"
            src={
              !call && windowWidth < 768
                ? data?.mobile_image?.url || "" //580
                : !call && windowWidth < 800
                  ? data?.tab_image?.url || ""
                  : !call && windowWidth < 1024
                    ? data?.desktop_image?.url || ""
                    : !call && windowWidth < 1400
                      ? data?.large_desktop_image?.url || ""
                      : !call && windowWidth >= 1400
                        ? data?.large_desktop_image?.url || ""
                        : ""
            }
            alt={data?.contact_us_desktop_image?.alt || "image"}
          />
        </article>
        <article className={s.article_content}>
          <div className={s.text_content}>
            <h3 className={title_fw_style}>{data?.about_mb_title}</h3>
            <div className={`${secondaryFont} title`}>
              <PrismicRichText field={data?.about_mb_description || []} />
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default AboutMBVariant;
